import React, { Suspense } from 'react';
import { PermissionsType } from '@/common/permissionsConst';
import { Themes } from '@maxtropy/components';

const Overview = React.lazy(() => import(/* webpackChunkName: "Overview" */ `./index`));
const routes = [
  {
    path: '/energyStorage/stationOperation/overview',
    permission: PermissionsType.P_BSAASSETOPSSUMMARY,
    theme: Themes.DARK,
    element: (
      <Suspense fallback={null}>
        <Overview />
      </Suspense>
    ),
  },
];

export default routes;
